"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRowHeight = 35;
exports.getHeaderRowHeight = (initialRowHeight) => initialRowHeight === "compact" ? exports.defaultRowHeight : exports.getRowHeight(initialRowHeight);
exports.getRowHeight = (initialRowHeight) => {
    switch (initialRowHeight) {
        case "compact":
            return 22;
        case "regular":
            return exports.defaultRowHeight;
        default:
            return initialRowHeight || exports.defaultRowHeight;
    }
};
//# sourceMappingURL=DataTable.util.js.map